module.exports = __webpack_public_path__ + "static/media/loader.e6dc13a0.svg";